import React, { useState, useEffect } from 'react';
import wa from '../../img/WA.png';
import "../../style/MobileMenu.css";

import {  LoadingOutlined,CloseOutlined } from '@ant-design/icons';
import { useAuth  } from '../../contexts/AuthContext'
import { logEvent } from "firebase/analytics";
import { analytics } from "../../Firebase";



function ContactModal({setIsOpen , pricing}) {

    const {isLoading, sendMessage} = useAuth()

    const [name, setName] = useState('');
    const [phone, setPhone] = useState("");
    const [day, setDay] = useState("");
    const [hour, setHour] = useState("");
    const [plan, setPlan] = useState("none");

    const [sent, setSent] = useState(false);


    useEffect(() => { 
        name && setSent(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

    const handleSubmit = (event) => {
        event.preventDefault();
        sendMessage(name, phone, day, hour,plan)
        logEvent(analytics, 'message_sent')
        setDay("")
        setHour("")
        setName("")
        setPhone("")
        setPlan("none")
        setSent(true)
    }


  return (
    <form  onSubmit={handleSubmit} className='wrapper-container-login mobile-menu-overlay' style={{display:'flex'}}>
        <div className='wrapper-login'>
       
        <div className='title-wrapper'>
      <div className='title-back'>
            <p className='header-contact-modal-text'>Nous contacter</p>
            </div> 
            <CloseOutlined className='close' onClick={() => setIsOpen(false)}/>
          </div>
            <div className='header-login header-contact-modal'>
                <p className='text'>Remplissez ce formulaire pour obtenir votre essai gratuit.</p>
            </div>


            <div className='input-container '>
              <input
              className='imput-contact-modal '
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                placeholder='Nom et prénom'
              />
            </div>

            <div className='input-container '>
              <input
              className='imput-contact-modal '
                
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                placeholder='Numero de téléphone'
              />
            </div>

         {pricing &&   <div className='input-container'>
          <select
            className='imput-contact-modal '
            id="plan"
            value={plan}
            onChange={(e) => setPlan(e.target.value)}
            required
          >
            <option value="none">Choisir une formule</option>
            <option value="starter">Starter - 29 €</option>
            <option value="standard">Booster - 69 €</option>
            <option value="premium">Expert - 99 €</option>
          </select>
        </div>}

            <div className='input-container'>
          <select
            className='imput-contact-modal '
            id="day"
            value={day}
            onChange={(e) => setDay(e.target.value)}
            required
          >
            <option value="">Choisir un jour</option>
            <option value="demain">Demain</option>
            <option value="Lundi">Lundi</option>
            <option value="Mardi">Mardi</option>
            <option value="Mercredi">Mercredi</option>
            <option value="Jeudi">Jeudi</option>
            <option value="Vendredi">Vendredi</option>
            <option value="Samedi">Samedi</option>
          </select>
        </div>

        <div className='input-container'>
          <select
            className='imput-contact-modal'
            id="hour"
            value={hour}
            onChange={(e) => setHour(e.target.value)}
            required
          >
            <option value="">Choisir une heure</option>
            <option value="10h">10h00</option>
            <option value="11h">11h00</option>
            <option value="12h">12h00</option>
            <option value="14h">14h00</option>
            <option value="15h">15h00</option>
            <option value="16h">16h00</option>
            <option value="17h">17h00</option>
            <option value="18h">18h00</option>

          </select>
        </div>

                
        <div  className='button-container button-container-modal' >
               
               <button  type="submit" className='google-button button-contact-modal black' >
             {!isLoading && !sent && <p>Envoyer</p>}

             { isLoading && <LoadingOutlined style={{margin:0}} spin />  }

            {!isLoading && sent && <p>Message envoyé</p>}
                
                 </button> 

 
             </div>
               
             <div className='google-button transparent ' onClick={()=> {logEvent(analytics, 'message_WA');  window.open(`https://wa.me/message/NR5ALYUJYWENM1`,'_blank', 'rel=noopener noreferrer')}}>
               <img className='wa'  src={wa} alt="Logo" />
              <p>Contact sur Whatsapp</p>

                   </div> 


         </div>
        
    </form>
  )
}

export default ContactModal